import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: 'app.component.html'
})
export class AppComponent { }



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/app.component.ts